import React, { useEffect, useState } from "react";
import { Table, Button, IconPlus, Search, Accordion,Select } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import { numberFormatComma } from "../../../common/js/utils/numberFormat";
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import RunlengthUpload from "./RunLengthUpload";

const RunLengthNewRender = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [runLengthv2, setrunLengthv2]=useState([]);
    const [runLengthgcp, setrunLengthgcp]=useState([]);
    const [runLengthlp, setrunLengthlp]=useState([]);
    const [selectMonthRun,setselectMonthRun]=useState([]);
    const [RunLengthMonth, setRunLengthMonth]=useState([]);
    const [dateSelected, setDateSelected] = useState();

    //Metodos
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    const fetchData = async () => {
        setDateSelected('');

        connectApi.get(
            "api/Channels/AllTables",
            { params: { viewRequired: 'run_length' } },
            dataResponseLoad
        ).catch((error) => {
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
    };
    const dataResponseLoad = (status, data) => {
        setDateSelected( moment(data['date']).format("MM-DD-YYYY") );
        data['runLength'].forEach(x => {
            x.monthYear = moment(x.monthYear).format("MMM/DD/YYYY");
            x.startDate = moment(x.startDate).format("MMM/DD/YYYY");
            x.endDate = moment(x.endDate).format("MMM/DD/YYYY");
            x.tpi=numberFormatComma(
                x.tpi
                );
        })
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
        fetchrunlength();
    }, []);

    const fetchrunlength=async()=>{
        connectApi.get(
            "api/Channels/Runlength",
            null,
            dataResponserun
        ).catch((error) => {
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
    }

    const dataResponserun=(status,data)=>{
        let gcp=[];
        let lp=[];
        if (data.length>0){
            data.forEach(element => {
                if (element.type=="GCP"){
                    gcp.push(element);
                }else{
                    lp.push(element);
                }
            });
            gcp.map((item,key)=>{
                item.monthYear=moment(
                    item.monthYear
                  ).format("MMM YYYY")
            });
            lp.map((item,key)=>{
                item.monthYear=moment(
                    item.monthYear
                  ).format("MMM YYYY")
            });
            
            let dates=data.map(item=>item.monthYear).filter(onlyUnique).reverse();
            let datesformat=dates.map((item,key)=>{
                return{
                    value: moment(item).format("DD/MMM/YYYY"),
                    label: item,
                };
            });
            setselectMonthRun(datesformat);
            setRunLengthMonth(datesformat[0].value);
            setrunLengthgcp(gcp);
            setrunLengthlp(lp);
            setrunLengthv2(data);
        }
        
    }
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if (  orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } if( orderBy === "channel" || orderBy === "name" 
            || orderBy === "createdBy" || orderBy === "classification" 
            || orderBy === "description" || orderBy==="namecustomer" || orderBy==="nameEndUser" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate"
                || orderBy === "date" || orderBy === "monthYear" ){
   
                    
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    //Vista
    const TableGCP=()=>{
        const [idpressFilterValue, setidpressFilterValue]=useState("");
        const [customerFilterValue, setcustomerFilterValue]=useState("");
        const [enduserFilterValue, setenduserFilterValue]=useState("");
        const columns = [
            
            {
                id:'namecustomer',
                label:"Name Customer",
                filter: (
                    <Search
                        id="customer-search"
                        value={customerFilterValue}
                        onChange={setcustomerFilterValue}
                    />
                )
            },
            {
                id:'nameEndUser',
                label:'Name End User',
                filter: (
                    <Search
                        id="enduser-search"
                        value={enduserFilterValue}
                        onChange={setenduserFilterValue}
                    />
                )
            },
            {
                id: 'idPress',
                label: 'Press',
                filter: (
                    <Search
                        id="idpress-search"
                        value={idpressFilterValue}
                        onChange={setidpressFilterValue}
                    />
                )
            },
            {
                id: 'monthYear',
                label: 'MonthYear',
            },
            {
                id: 'limitInitial',
                label: 'Initial Shets',
            },
            {
                id: 'limitFinal',
                label: 'Final Shets',
            },
            {
                id: 'result',
                label: 'Shets',
            },
        ];
        const [orderBy, setOrderBy] = useState('namecustomer');
        const [orderType, setOrderType] = useState('ascending');
        const [order, setOrder] = useState(columns.map((c) => c.id));
        const [orderActive, setOrderActive] = useState(
            columns.map((c) => c.id)
            );
        const filteredData = filterSort(
            runLengthgcp, {
                monthYear: moment(RunLengthMonth).format("MMM YYYY"),
                nameEndUser:enduserFilterValue,
                namecustomer:customerFilterValue,
                idPress:idpressFilterValue

            },
            orderBy,
            orderType
        );
        const handleOnColumnReorder = (newOrder) => {
            setOrderActive(newOrder);
            setOrder(newOrder);
        };
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        
        
        return (
            <>
            <Table
                columns={columns}
                data={filteredData}
                loadingDataLength={5}
                onColumnReorder={handleOnColumnReorder}
                columnReorder
                showFilters
                onSort={handleSort}
                preferences={{
                    defaultOrder: columns.map((c) => c.idPress),
                    order,
                    sortBy: {
                        id: 'limitInitial',
                        type: 'ascending',
                        id: orderBy,
                        type: orderType,
                    }
                }}
            />
            </>
        );
    }
    const TableLP=()=>{
        const [idpressFilterValue, setidpressFilterValue]=useState("");
        const [customerFilterValue, setcustomerFilterValue]=useState("");
        const [enduserFilterValue, setenduserFilterValue]=useState("");
        const columns = [
            
            {
                id:'namecustomer',
                label:"Name Customer",
                filter: (
                    <Search
                        id="customer-search"
                        value={customerFilterValue}
                        onChange={setcustomerFilterValue}
                    />
                )
            },
            {
                id:'nameEndUser',
                label:'Name End User',
                filter: (
                    <Search
                        id="enduser-search"
                        value={enduserFilterValue}
                        onChange={(value)=>{
                        setenduserFilterValue(value)
                        }}
                    />
                )
            },
            {
                id: 'idPress',
                label: 'Press',
                filter: (
                    <Search
                        id="idpress-search"
                        value={idpressFilterValue}
                        onChange={setidpressFilterValue}
                    />
                )
            },
            {
                id: 'limitInitial',
                label: 'Initial Meters',
            },
            {
                id: 'limitFinal',
                label: 'Final Meters',
            },
            {
                id: 'result',
                label: 'Meters',
            },
        ];


        const [orderBy, setOrderBy] = useState('namecustomer');
        const [orderType, setOrderType] = useState('ascending');
        const [order, setOrder] = useState(columns.map((c) => c.id));
        const [orderActive, setOrderActive] = useState(
            columns.map((c) => c.id)
            );
        const filteredData = filterSort(
            runLengthlp, {
                monthYear: moment(RunLengthMonth).format("MMM YYYY"),
                nameEndUser:enduserFilterValue,
                namecustomer:customerFilterValue,
                idPress:idpressFilterValue
            },
            orderBy,
            orderType
        );
        const handleOnColumnReorder = (newOrder) => {
            setOrderActive(newOrder);
            setOrder(newOrder);
        };
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        return (
            <>
            <Table
                columns={columns}
                data={filteredData}
                loadingDataLength={5}
                onColumnReorder={handleOnColumnReorder}
                columnReorder
                showFilters
                onSort={handleSort}
                preferences={{
                    defaultOrder: columns.map((c) => c.idPress),
                    order,
                    sortBy: {
                        id: 'limitInitial',
                        type: 'ascending',
                        id: orderBy,
                        type: orderType,
                    }
                }}
            />
            </>
        );
    }
    
    const [ShowModalRunLength,setShowModalRunLength]=useState(false);
    
    const [data, setData] = React.useState([
        {
            content: <TableGCP/>,
            header: {
            centralArea: <span>GCP</span>
            },
            id: 'accordionItem1'
        },
        {
            content: <TableLP/>,
            header: {
                centralArea: <span>L&P</span>
            },
            id: 'accordionItem2'
        },
    ]);
    const handleExpand = (event, index, item) => {
        const updatedData = [...data];
        updatedData[index].expanded = true;
        setData(updatedData);
    };

    const handleCollapse = (event, index, item) => {
        const updatedData = [...data];
        updatedData[index].expanded = false;
        setData(updatedData);
    };
    const closemodal=()=>{
        setShowModalRunLength(false);
    }
    const allgood=()=>{
        fetchrunlength();
        setShowModalRunLength(false);
        
    }
    const handleSelecAudience = (name) => (event) => {
        setRunLengthMonth(event.value);
    };
    
    const handleClearAudience = (name) => (event) => {
        setRunLengthMonth();
    };
    const showmodalagain=()=>{
        setShowModalRunLength(true)
    }
    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: 'css-la566w-padding-Button',
            cancelButton: 'css-k95t6a-padding-Button'
        },
        buttonsStyling: false
        })
    const sameMonthYear=()=>{
        let exists = runLengthv2.some((x) => moment(x.monthYear).format("MMM/DD/YYYY") == moment(dateSelected).format("MMM/DD/YYYY"));

        if (exists==true){
            swalWithBootstrapButtons.fire({
                title: "Warning",
                html: "Exist data from the same period, if you continue the previous data will be delete",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText:'Return',
                }).then((result) => {
                if (result.isConfirmed) {
                    setShowModalRunLength(true);

                }
                })
        }else{
            setShowModalRunLength(true);
        }
    }
    return (
        <>
        <Row>
            <Col style={{
                    marginTop: "5px",
                    marginBottom:"5px"
            }}>
                <Button
                    leadingIcon={<IconPlus />}
                    onClick={() => {sameMonthYear()}}
                    //loading={loadingData}
                >{t("addNew")} Run Length</Button>
            </Col>
            <Col>
            <Select
                options={selectMonthRun}
                id="select-usage"
                label="Select"
                value={[RunLengthMonth]}
                onClear={handleClearAudience()}
                onChange={handleSelecAudience()}
            />
            </Col>
            
        </Row>
        <Row>
            <Col>
                <Accordion appearance="outlined"
                    behavior="singleExpand"
                    items={data}
                    gutter={10}
                    onCollapse={handleCollapse}
                    onExpand={handleExpand}
                />
            </Col>
        </Row>
        <RunlengthUpload onShowModal={ShowModalRunLength} confirmationFunction={allgood} onCloseModal={closemodal} showmodalagin={showmodalagain} />
        </> 
    )
}

export default RunLengthNewRender;
